import { useState } from "react";

import { useIntl } from "react-intl";

import { Button } from "@/components/atoms/Button";
import { Text } from "@/components/atoms/Text";
import { cn } from "@/lib/utils";

interface DescriptionProps {
  description: string;
  textSmall?: boolean;
}

export default function Description({
  description = "",
  textSmall = false,
}: DescriptionProps) {
  const [truncDesc, setTruncDesc] = useState(true);
  const intl = useIntl();

  const buttonText = truncDesc
    ? intl.formatMessage({
        id: "shared_components.listing_description.read_more_btn",
        defaultMessage: "Read More",
      })
    : intl.formatMessage({
        id: "shared_components.listing_description.hide_btn",
        defaultMessage: "Hide",
      });

  return (
    description && (
      <div className={cn(truncDesc && "tw-flex")}>
        <Text
          typeface={textSmall ? "body-1-long" : "body-2"}
          className={cn("tw-text-gray-600", truncDesc && "tw-truncate")}
        >
          {description}
        </Text>
        {description.length > 114 && (
          <Button
            appearance="gray"
            variant="underline"
            onClick={() => setTruncDesc(!truncDesc)}
          >
            <Text typeface={textSmall ? "body-1-long" : "body-2"}>
              {buttonText}
            </Text>
          </Button>
        )}
      </div>
    )
  );
}
